import React, {useEffect} from 'react';
import {GoogleLogin} from 'react-google-login';
import Axios from 'axios';
import {Helmet} from 'react-helmet';

export default function Login() {
    
    useEffect(() => {
        Axios.get("https://docsserver.onrender.com");
    },[]);

    async function responseGoogle(response)
    {
        //console.log(response);
        const url = `https://docsserver.onrender.com/getToken/verify`;
        const data = {
            token: response.tokenId,
            email: response.profileObj.email
        }
        
        const res = await Axios.post(url, data);
        //console.log(res);
        if(res.data == "Verified user")
        {
            //console.log("User Verify");
            localStorage.setItem('authData',JSON.stringify(data));
            window.location.reload();
        }
        else{
            //console.log("No res");
        }
    }

    return (
            <section className='flex flex-col justify-center items-center h-screen'>
            <Helmet>
                <title>Login - Docx</title>
            </Helmet>
            <div className='flex items-center space-x-1'>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 text-blue-500 mb-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                </svg>
                <span className='text-3xl text-gray-600 font-semibold main-font'>Docx</span>
            </div>
        
            <GoogleLogin
                clientId="852762241490-gr45nghc45rkvjp5bs3uqvr4q0qkp80h.apps.googleusercontent.com"
                buttonText="Login"
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
                cookiePolicy={'single_host_origin'}
            />

            <div className='mt-5 text-right'><p>By <br/><span className='font-bold text-2xl'>Keerthi Vibisan S</span></p></div>
            
            <div className="mt-8 md:w-[35%] p-4 border-t-2 border-black">
               <p className="font-bold text-xl">🙋‍♂️ Note</p>
               <ul className="p-2 list-disc">
                 <li>Try SignIn 2 to 3 times, the backend server may be Sleep, as it is hosted for free</li>
                 <li className="bg-blue-500 w-fit p-1"><span className="text-white">This app is only for <b>demo</b> purpose</span></li>
               </ul>
             </div>
        </section>
    )
}
